export default __webpack_public_path__ + "static/media/slide1.bc90771b.jpg";